import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { MatchProvider, useMatch, useSectionSpy } from "@/match/MatchContext";
import { HERO_PHOTO_URL, SECTIONS } from "@/data/content";
import KickoffOverlay from "@/components/KickoffOverlay";
import Scoreboard from "@/components/Scoreboard";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import StorySection from "@/components/StorySection";
import HalfTime from "@/components/HalfTime";
import SearchSection from "@/components/SearchSection";
import BuildingSection from "@/components/BuildingSection";
import FullTime from "@/components/FullTime";
import Shootout from "@/components/Shootout";
import FinalResult from "@/components/FinalResult";
import CommentaryOverlay from "@/components/CommentaryOverlay";
import Footer from "@/components/Footer";

function Spied({ id, children }) {
  const ref = useSectionSpy(id);
  return (
    <section id={id} ref={ref}>
      {children}
    </section>
  );
}

function LandingPage() {
  const [showIntro, setShowIntro] = useState(true);
  const { lenisRef } = useMatch();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, [lenisRef]);

  return (
    <div className="grain" data-testid="landing-page">
      <AnimatePresence>
        {showIntro && <KickoffOverlay onDone={() => setShowIntro(false)} />}
      </AnimatePresence>
      <Scoreboard />
      <main>
        <Hero photoUrl={HERO_PHOTO_URL} />
        <Marquee />
        <HowItWorks />
        <Spied id="captain">
          <StorySection section={SECTIONS.captain} />
        </Spied>
        <Spied id="reality">
          <StorySection section={SECTIONS.reality} flip bg="#ECE8E0" />
        </Spied>
        <Spied id="halftime">
          <HalfTime />
        </Spied>
        <Spied id="search">
          <SearchSection />
        </Spied>
        <Spied id="building">
          <BuildingSection />
        </Spied>
        <Spied id="fulltime">
          <FullTime />
        </Spied>
        <Spied id="shootout">
          <Shootout />
        </Spied>
        <Spied id="final">
          <FinalResult />
        </Spied>
      </main>
      <Footer />
      <CommentaryOverlay />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MatchProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </MatchProvider>
    </BrowserRouter>
  );
}

export default App;
